import { ChangeDetectionStrategy, Component, computed, signal, ViewEncapsulation } from '@angular/core';

let inputId = 0;

@Component({
    selector: 'ui-captcha-input',
    standalone: true,
    templateUrl: './captcha-input.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'relative contents overflow-hidden',
    },
})
export class CaptchaInputComponent {
    value = signal<string | null>(null);

    valid = computed(() => {
        return this.value() === undefined || this.value() === null;
    });

    inputId = `input-captchaId-${inputId++}`;
}
